import { render } from "./CTable.vue?vue&type=template&id=0ea49aa8&scoped=true"
import script from "./CTable.vue?vue&type=script&lang=js"
export * from "./CTable.vue?vue&type=script&lang=js"

import "./CTable.vue?vue&type=style&index=0&id=0ea49aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea49aa8"]])

export default __exports__